module.exports = __webpack_public_path__ + "img/NPXS.e4d48bf1.svg";